query PaymentSearch(
  $first: Int
  $after: Cursor
  $orderBy: [PaymentsOrderBy!]
  $filter: PaymentFilter
  $isHistorySearch: Boolean
  $isLinkSearch: Boolean
  $paymentSearchSearchRequest: SearchRequestInput
) {
  paymentSearch(
    first: $first
    after: $after
    filter: $filter
    isHistorySearch: $isHistorySearch
    isLinkSearch: $isLinkSearch
    orderBy: $orderBy
    searchRequest: $paymentSearchSearchRequest
  ) {
    nodes {
      id
      _rowTimestamp
      _isUpdatable
      _isDeletable
      _statusTypeId
      _isTransactionPayment
      _payCycleDescription
      payCycle {
        isDraft
      }
      statusType {
        approvalState
        statusType
        _transactionIconStatus
      }
      company {
        id
        name
      }
      _isAccountingEntryStampedComplete
      currency {
        id
        isoCode
      }
      businessUnit {
        id
        name
      }
      paymentReference
      _baseCurrencyAmount
      _spotCurrencyAmount
      paidAmount
      _invoiceTotal
      paidDate
      vendorReference
      paymentAccount {
        name
        bankAccountNumber
      }
      transactionType {
        id
        transactionType
      }
    }

    pageInfo {
      hasNextPage
      hasPreviousPage
      endCursor
    }
  }
}
